export const ROOT = "/admin/counterfeit-report";
export const COUNTERFEIT_DETAIL = `${ROOT}/View/:serialNum`;
